<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>销售管理</el-breadcrumb-item>
      <el-breadcrumb-item>未报账门店列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-date-picker
      v-model="orderRequest.selectDate"
      type="daterange"
      range-separator="至"
      size="mini"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      @change="selectKpiData"
      value-format="yyyy-MM-dd"
    >
    </el-date-picker>
    <el-button size="mini"  style="margin-left: 5px;" @click="queryOrder">查询</el-button>
    <el-table height="590px" :data="shopList" fit border stripe="stripe"
              :header-cell-style="{background:'#eff3f8', color:'#333', fontWeight:700}"
              :row-style="{height: '0'}"
    >
      <el-table-column
        type="index"
        width="50">
      </el-table-column>
      <el-table-column
        align="center"
        prop="areaName"
        label="区域" width="140"
      >
      </el-table-column>

      <el-table-column
        align="center"
        prop="orgName"
        label="门店" width="140"
      >
      </el-table-column>

      <el-table-column
        align="center"
        prop="state"
        :formatter="stateFormatter"
        label="门店状态" width="140"
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data(){
    return{
      shopList:[],
      orderRequest:{
        selectDate:'',
        startDate:'',
        endDate:'',
      },
      stateText:[
        {state:1, name:'营业中'},
        {state:2, name:'已闭店'}
      ],
    }
  },
  methods:{
    selectKpiData(){
      if (this.orderRequest.selectDate === null){
        this.orderRequest.startDate = '';
        this.orderRequest.endDate = '';
      } else {
        this.orderRequest.startDate = this.orderRequest.selectDate[0];
        this.orderRequest.endDate = this.orderRequest.selectDate[1];
      }
    },
    async queryOrder(){
      const {data:res} = await this.$http.get(`/no/order/shop/${this.orderRequest.startDate}/${this.orderRequest.endDate}`)
      if (res.code !== 200){
        return this.$message.error("获取订单列表失败！")
      }
      this.shopList = res.data;
    },
    stateFormatter(row){
      let value = "";
      for (let i = 0; i < this.stateText.length; i++){
        let item = this.stateText[i];
        if (row.state === item.state) {
          value = item.name;
          break;
        }
      }
      return value;
    },
  }
}
</script>

<style scoped lang="less">
.el-table, .el-table__cell {
/deep/ th {
  padding: 2px ;
}
/deep/ td {
  padding: 2px ;
}
}
</style>



// WEBPACK FOOTER //
// src/components/NoOrderShop.vue